import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
} from "@mui/material";

const CreateFolderDialog = ({
  open,
  onClose,
  folderName,
  setFolderName,
  onCreate,
}) => {
  const dialogPaperSx = {
    borderRadius: "18px",
    background: "rgba(255,255,255,0.96)",
    backdropFilter: "blur(10px)",
    boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
    overflow: "hidden",
  };

  const fieldSx = {
    mt: 1.25,
    "& .MuiOutlinedInput-root": {
      backgroundColor: "rgba(255,255,255,0.96)",
      borderRadius: "10px",
    },
  };

  const primaryButtonSx = {
    backgroundColor: "#2f63ad",
    color: "white",
    fontWeight: 700,
    borderRadius: "10px",
    textTransform: "none",
    px: 2.25,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#1f4f94",
      boxShadow: "none",
    },
  };

  const secondaryButtonSx = {
    borderRadius: "10px",
    textTransform: "none",
    fontWeight: 600,
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: dialogPaperSx }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: 700,
          fontSize: "1.35rem",
          pt: 3,
          pb: 1,
          color: "#1f1f1f",
        }}
      >
        Create New Folder
      </DialogTitle>

      <DialogContent sx={{ px: 3, pb: 1 }}>
        <Typography
          sx={{
            mt: 0.5,
            mb: 1,
            textAlign: "center",
            color: "#666",
            fontSize: "0.95rem",
          }}
        >
          Enter a name for your new folder.
        </Typography>

        <TextField
          autoFocus
          fullWidth
          variant="outlined"
          label="Folder Name"
          placeholder="e.g. Project Files"
          value={folderName}
          onChange={(e) => setFolderName(e.target.value)}
          sx={fieldSx}
        />
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          pt: 1.5,
          justifyContent: "center",
          gap: 1.25,
        }}
      >
        <Button onClick={onClose} variant="outlined" sx={secondaryButtonSx}>
          Cancel
        </Button>

        <Button
          onClick={onCreate}
          variant="contained"
          disabled={!folderName.trim()}
          sx={primaryButtonSx}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateFolderDialog;
